<template>
	<div class="select-option flex" :class="{'z-crt': selected, 'z-dis': disabled}" @click="clickHandle">
		<div class="flex-column flex-grow">
			<h5>{{name}}</h5>
			<p v-for="(item, i) in info" :key="i">{{item}}</p>
		</div>
		<c-tooltip v-if="image" position="left" color="white">
			<c-file class="image" :src="image" media :preview="false"></c-file>
			<template #tip>
				<c-file class="image-preview" :src="image" media :preview="false" style="width: 200px; height: 200px; border: none;"></c-file>
			</template>
		</c-tooltip>
	</div>
</template>

<script>
	import {mapGetters} from 'vuex'

	export default {
		name: 'selectOption',

		props: {
			image: String,
			name: String,
			info: Array,
			selected: Boolean,
			disabled: Boolean,
			vip: Boolean
		},

		computed: {
			...mapGetters(['freeEdition'])
		},

		methods: {
			clickHandle(e) {
				if (this.vip && this.freeEdition) {
					e.stopPropagation();
					this.freeEditionTips();
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.select-option  {
		gap: 6px;
		padding: 10px 8px;

		&.z-crt,
		&:hover {
			background: #F5F5F5;
		}

		&.z-dis {
			cursor: not-allowed;

			h5 {
				color: #999;
			}
		}

		.image {
			width: 14px;
			height: 14px;
		}

		div {
			gap: 4px;
		}

		h5 {
			line-height: 16px;
			font-size: 13px;
			font-weight: normal;
			word-break: break-all;
		}

		p {
			line-height: 14px;
			color: #999;
			font-size: 12px;
			word-break: break-all;
		}

		.vip {
			height: 14px;
		}
	}
</style>
